import AppFeedback from '@/components/AppFeedback.vue'

function normalizeNotifyArgs (arg1, arg2) {
  // $notify({ title, message, type, duration })
  if (arg1 && typeof arg1 === 'object' && !Array.isArray(arg1)) {
    return {
      title: arg1.title || '',
      message: arg1.message || '',
      type: arg1.type || 'info',
      duration: arg1.duration != null ? arg1.duration : 2800
    }
  }
  // fallback
  return {
    title: '',
    message: String(arg1 || arg2 || ''),
    type: 'info',
    duration: 2800
  }
}

function normalizeMessageArgs (arg1, type) {
  // $message('text') | $message({ message, type, duration }) | $message.success('text')
  if (arg1 && typeof arg1 === 'object' && !Array.isArray(arg1)) {
    return {
      title: '',
      message: arg1.message || '',
      type: arg1.type || type || 'info',
      duration: arg1.duration != null ? arg1.duration : 2800
    }
  }
  return {
    title: '',
    message: String(arg1 || ''),
    type: type || 'info',
    duration: 2800
  }
}

export default {
  install (VueCtor) {
    const FeedbackCtor = VueCtor.extend(AppFeedback)
    const instance = new FeedbackCtor()
    instance.$mount()
    document.body.appendChild(instance.$el)

    const toast = (options) => instance.showToast(options)

    const notify = function (options) {
      return toast(normalizeNotifyArgs(options))
    }
    notify.success = (options) => toast({ ...normalizeNotifyArgs(options), type: 'success' })
    notify.warning = (options) => toast({ ...normalizeNotifyArgs(options), type: 'warning' })
    notify.error = (options) => toast({ ...normalizeNotifyArgs(options), type: 'error' })
    notify.info = (options) => toast({ ...normalizeNotifyArgs(options), type: 'info' })

    const message = function (options) {
      return toast(normalizeMessageArgs(options))
    }
    message.success = (msg) => toast(normalizeMessageArgs(msg, 'success'))
    message.warning = (msg) => toast(normalizeMessageArgs(msg, 'warning'))
    message.error = (msg) => toast(normalizeMessageArgs(msg, 'error'))
    message.info = (msg) => toast(normalizeMessageArgs(msg, 'info'))

    const alertFn = function (messageText, title, options = {}) {
      // Element UI: $alert(message, title, options) → Promise
      const opts = typeof title === 'object' ? title : (options || {})
      const resolvedTitle = typeof title === 'string' ? title : (opts.title || 'Мэдэгдэл')
      return instance.showAlert({
        title: resolvedTitle,
        message: String(messageText || ''),
        confirmText: opts.confirmButtonText || 'Баярлалаа',
        showCancel: false
      }).then(() => true)
    }

    const confirmFn = function (messageText, title, options = {}) {
      const opts = typeof title === 'object' ? title : (options || {})
      const resolvedTitle = typeof title === 'string' ? title : (opts.title || 'Баталгаажуулах')
      return instance.showAlert({
        title: resolvedTitle,
        message: String(messageText || ''),
        confirmText: opts.confirmButtonText || 'Тийм',
        cancelText: opts.cancelButtonText || 'Үгүй',
        showCancel: true
      }).then((ok) => {
        if (ok) return true
        return Promise.reject(new Error('cancel'))
      })
    }

    VueCtor.prototype.$toast = toast
    VueCtor.prototype.$notify = notify
    VueCtor.prototype.$message = message
    VueCtor.prototype.$alert = alertFn
    VueCtor.prototype.$confirm = confirmFn

    // Keep MessageBox-like shape used by Element sometimes
    VueCtor.prototype.$msgbox = {
      alert: alertFn,
      confirm: confirmFn
    }
  }
}
